import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { StandardCard } from '../styles/standardStyles';
import './InventoryCalculator.css';

const InventoryCalculator = ({ goTo, fromOnboarding = false, onContinue }) => {
  const [showStep4Popup, setShowStep4Popup] = useState(false);

  // Show step 4 popup when component mounts (only outside onboarding)
  useEffect(() => {
    if (!fromOnboarding) {
      setShowStep4Popup(true);
      const timer = setTimeout(() => {
        setShowStep4Popup(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [fromOnboarding]);

  return (
    <div className="ic-page">
      <div className="ic-title-wrapper">
        <h2 className="ic-title">Inventory Recovery</h2>
      </div>

      <StandardCard className="ic-card">
        <div className="ic-card-inner">
          <div className="ic-logo-circle">
            <FontAwesomeIcon icon={faClipboardList} className="ic-logo" />
          </div>

          <h3 className="ic-heading">
            Calculate Your Starting
            <br />
            Inventory
          </h3>

          <p className="ic-desc">
            Instantly calculate your starting inventory with zero effort using two past purchase bills.
            Our system cross-references the data to set accurate stock levels automatically, skipping hours of
            manual counting.
          </p>

          <button className="ic-cta" onClick={() => {
            if (fromOnboarding && onContinue) onContinue();
            goTo && goTo('stock-in-scan');
          }}>
            Let's Get Started
          </button>
        </div>
      </StandardCard>

      <div className="ic-footnote">Get an immediate forecast of ingredient needs</div>

      {/* Step 4 Completion Popup */}
      {showStep4Popup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          animation: 'fadeIn 0.3s ease-in-out'
        }}>
          <div style={{
            background: '#2c2c2c',
            color: 'white',
            padding: '40px 60px',
            borderRadius: '16px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: '600',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            animation: 'scaleIn 0.3s ease-out'
          }}>
            step 4 out of 5 completed
          </div>
        </div>
      )}
    </div>
  );
};

export default InventoryCalculator;
